module.exports = __webpack_public_path__ + "img/wuyi-pop.9ea642a0.png";